<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform: capitalize">
            Sale Quotations
          </h3>
          <div class="text-right col-lg-12 col-5">
            <div class="table-filters" />
          </div>
        </div>

        <!-- Custom Tailwind CSS Table -->
        <div class="overflow-x-auto">
          <table class="min-w-full bg-white border border-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b"
                >
                  Customer
                </th>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b"
                >
                  Date
                </th>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b"
                >
                  Total
                </th>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b"
                >
                  Status
                </th>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr
                v-for="quotation in userQuotations"
                :key="quotation.userQuotationId"
                class="hover:bg-gray-50"
              >
                <td
                  class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 border-b"
                >
                  {{ quotation.user.firstName + " " + quotation.user.lastName }}
                </td>
                <td
                  class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 border-b"
                >
                  {{ formatDate(quotation.createdAt) }}
                </td>
                <td
                  class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 border-b"
                >
                  ₹{{ quotation.total }}
                </td>
                <td class="px-4 py-3 whitespace-nowrap text-sm border-b">
                  <span
                    v-if="quotation.status"
                    class="inline-flex px-2 py-1 text-xs font-semibold rounded-full"
                    :class="{
                      'bg-red-100 text-red-800':
                        quotation.status.code === 'pending',
                      'bg-orange-100 text-orange-800':
                        quotation.status.code === 'dispatched',
                      'bg-green-100 text-green-800':
                        quotation.status.code === 'accepted',
                      'bg-gray-100 text-gray-800':
                        quotation.status.code === 'declined'
                    }"
                  >
                    {{ quotation.status.label }}
                  </span>
                </td>
                <td
                  class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 border-b"
                >
                  <div class="relative inline-block text-left">
                    <button
                      @click="toggleDropdown(quotation.userQuotationId)"
                      class="inline-flex justify-center w-full px-3 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      Actions
                      <svg
                        class="w-4 h-4 ml-2 -mr-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>

                    <!-- Dropdown Menu -->
                    <div
                      v-if="activeDropdown === quotation.userQuotationId"
                      class="absolute right-0 z-10 w-48 mt-2 origin-top-right bg-white border border-gray-200 rounded-md shadow-lg ring-1 ring-black ring-opacity-5"
                    >
                      <div class="py-1">
                        <button
                          @click="handleAction(quotation, 'edit')"
                          class="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                        >
                          Edit
                        </button>
                        <button
                          @click="handleAction(quotation, 'whatsApp')"
                          class="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                        >
                          Send To Whatsapp
                        </button>
                        <button
                          @click="handleAction(quotation, 'print')"
                          class="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                        >
                          Print
                        </button>
                        <button
                          @click="handleAction(quotation, 'convertSale')"
                          class="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                        >
                          Convert To Sale
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="card-footer d-flex justify-content-center py-3">
          <el-pagination
            @current-change="handlePageChange"
            :current-page.sync="currentPage"
            :page-size="perPage"
            :total="totalItems"
            layout="prev, pager, next"
            background
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- Dialogs -->
    <el-dialog
      :visible.sync="showSaleQuotationModal"
      title="Sale Quotation Invoice"
      width="50%"
    >
      <sale-quotation-design
        :data="quotationData"
        @close="showSaleQuotationModal = false"
      />
    </el-dialog>
    <el-dialog
      :visible.sync="isSaleConfirmationModal"
      title="Quotation to Sale "
      width="30%"
    >
      <div>
        <p class="py-4">
          Are you sure, do you want to covert quotation for customer
          <span
            class="capitalize"
            v-if="this.quotationData && this.quotationData.user"
          >
            {{
              this.quotationData.user.firstName +
                " " +
                this.quotationData.user.lastName
            }}
          </span>
          to sale ?
        </p>
        <div class="flex gap-4">
          <button
            @click="handleConvertQuotationToSale()"
            class="px-6 py-2 text-white bg-blue-500 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Yes
          </button>
          <button
            @click="isSaleConfirmationModal = false"
            class="px-6 py-2 text-white bg-blue-500 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            No
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import headerComponent from "../Components/HeaderComponent";
import { mapActions, mapState } from "vuex";
import dateFns from "date-fns";
import { print } from "@/utils/print";
import SaleQuotationDesign from "./SaleQuotationDesign.vue";

import {
  Select,
  Option,
  DatePicker,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button,
  Tag,
  Pagination
} from "element-ui";
import { mapGetters, mapMutations } from "vuex/dist/vuex.common.js";
export default {
  components: {
    [Tag.name]: Tag,
    [Pagination.name]: Pagination,
    "header-component": headerComponent,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "sale-quotation-design": SaleQuotationDesign
  },

  data: () => {
    return {
      showSaleQuotationModal: false,
      isSaleConfirmationModal: false,
      quotationData: {},
      currentPage: 1,
      perPage: 10,
      activeDropdown: null // Track which dropdown is open
    };
  },
  computed: {
    ...mapState("user", ["userQuotations", "userQuotationMeta"]),
    ...mapGetters({
      paymentModes: "paymentMode/getPaymentModes",
      statuses: "status/getStatusList"
    }),
    totalItems() {
      return this.userQuotationMeta.total || 0;
    }
  },
  beforeMount() {
    this.getUserQuotations({ page: this.currentPage });
    this.getPaymentModes();
    this.getStatuses();
  },
  mounted() {
    // Add click outside listener to close dropdowns
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    // Remove click outside listener
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    ...mapActions("user", [
      "getUserQuotations",
      "getUserQuotation",
      "printQuotation"
    ]),
    handleClickOutside(event) {
      // Close dropdown if clicking outside
      if (!event.target.closest(".relative")) {
        this.activeDropdown = null;
      }
    },
    ...mapActions("sale", ["createSale"]),
    ...mapActions({
      getPaymentModes: "paymentMode/getPaymentModes",
      getStatuses: "status/getStatusList",
      updateUserQuotation: "user/updateUserQuotation"
    }),
    ...mapMutations("sale", ["setSale"]),
    formatDate(value) {
      return dateFns.format(new Date(value), "YYYY-MM-DD");
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.getUserQuotations({ page });
    },
    async handleAction(userQuotation, command) {
      if (command === "edit") {
        this.$router.push("/sales/quotations/" + userQuotation.userQuotationId);
      }
      if (command === "print") {
        const quotationData = await this.getUserQuotation(
          userQuotation.userQuotationId
        );
        this.quotationData = quotationData;
        print(
          { ...quotationData, quotationUser: quotationData.user },
          "sale-quotation"
        );
      }
      if (command === "whatsApp") {
        const quotationData = await this.getUserQuotation(
          userQuotation.userQuotationId
        );
        this.quotationData = quotationData;
        this.showSaleQuotationModal = true;
      }
      if (command === "convertSale") {
        this.quotationData = userQuotation;
        this.isSaleConfirmationModal = true;
      }
    },
    toggleDropdown(quotationId) {
      this.activeDropdown =
        this.activeDropdown === quotationId ? null : quotationId;
    },
    async handleConvertQuotationToSale() {
      const saleData = {
        userId: this.quotationData.userId,
        products: this.quotationData.productMeta.map(i => {
          return {
            productId: i.productId,
            name: i.name,
            price: i.price,
            quantity: i.quantity,
            discount: i.discount,
            isPercentage: i.isPercentage,
            productPriceTypeId: i.productPriceTypeId,
            taxRate: i.taxRate
          };
        }),
        date: this.quotationData.createdAt,
        createdBy: this.quotationData.createdBy,
        discount: 0,
        paymentModeId: this.paymentModes[0].paymentModeId,
        paymentNote: "",
        amountPaid: 0
      };
      await this.setSale(saleData);
      this.createSale(saleData)
        .then(() => {
          const acceptedStatus = this.statuses.find(i => i.code === "accepted");
          this.updateUserQuotation({
            ...this.quotationData,
            statusId: acceptedStatus.statusId
          }).then(() => {
            this.getUserQuotations({ page: this.currentPage });
          });
          this.$notify({
            message: "Sale Saved Succesfully!",
            type: "success",
            title: "Success"
          });
          this.isSaleConfirmationModal = false;
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }
};
</script>
<style>
.dispatch-button {
  margin-left: 15px;
  margin-top: 20px;
}
.pending-status {
  background-color: #e72626;
  border-color: #e72626;
  color: #fff;
}
.dispatch-status {
  background-color: #f57316eb;
  border-color: #f57316eb;
  color: #fff;
}
.declined-status {
  background-color: #b0ccb3;
  border-color: #b0ccb3;
  color: #fff;
}
</style>
